import { useSearchParams } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Button from '@/components/base/Button';
import FAQAccordion from '@/pages/home/components/FAQAccordion';
import QuoteForm from './components/QuoteForm';
import { contactServiceOptions, infoCards, contactFaqs } from '@/mocks/contact';

export default function ContactPage() {
  const [params] = useSearchParams();
  const slug = params.get('service') || '';
  const preset = contactServiceOptions.find((o) => o.slug === slug)?.value || '';

  return (
    <SiteLayout>
      <title>Request a Cleaning Quote | Contact CLEARY</title>
      <meta name="description" content="Request a quote from CLEARY. Tell us about your home and the recurring, deep or move-in / move-out cleaning service you are looking for." />
      <section className="px-4 md:px-6 lg:px-20 pt-10 md:pt-16 pb-10 md:pb-14">
        <div className="max-w-content mx-auto"><div className="max-w-3xl fade-up">
          <p className="text-xs md:text-[13px] font-medium tracking-[0.14em] text-secondary-500 mb-4">GET IN TOUCH</p>
          <h1 className="font-heading text-[36px] md:text-[52px] lg:text-[60px] leading-[1.08] font-medium tracking-tight">Let&apos;s Make Your Space Feel Fresh.</h1>
          <p className="mt-5 text-base md:text-lg leading-[1.6] text-foreground-600 max-w-xl">Tell us a little about your home and the cleaning service you&apos;re looking for.</p>
        </div></div>
      </section>

      <section className="px-4 md:px-6 lg:px-20 pb-16 md:pb-20 lg:pb-[112px]">
        <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-6">
          <div className="lg:col-span-5 lg:pr-8">
            <h2 data-reveal="heading" className="font-heading text-[22px] md:text-[26px] leading-[1.3] font-medium">Start with a few details.</h2>
            <p className="mt-4 text-[15px] md:text-base leading-[1.6] text-foreground-600">Use the form to request a quote for recurring, deep or move-in / move-out cleaning. The more you share about your space, the easier it is for us to suggest the right option.</p>
            <ul data-reveal-group className="mt-8 flex flex-col gap-4">
              {infoCards.map((c) => (
                <li key={c.title} className="flex gap-4 rounded-2xl bg-background-100 border border-background-300 p-5">
                  <span className="w-10 h-10 rounded-full bg-background-50 text-secondary-500 flex items-center justify-center shrink-0"><i className={`${c.icon} text-lg`} /></span>
                  <div>
                    <h3 className="text-base font-medium">{c.title}</h3>
                    <p className="mt-1 text-sm leading-[1.6] text-foreground-600">{c.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-7">
            <QuoteForm key={preset} defaultService={preset} />
          </div>
        </div>
      </section>

      <FAQAccordion items={contactFaqs} eyebrow="BEFORE YOU ASK" title="Helpful Answers." className="bg-background-100" />

      <section className="px-4 md:px-6 lg:px-20 py-16 md:py-20 lg:py-[112px] text-center">
        <div className="max-w-2xl mx-auto">
          <h2 data-reveal="heading" className="font-heading text-[28px] md:text-[40px] leading-[1.15] font-medium tracking-tight">Every Home Is a Little Different.</h2>
          <p className="mt-5 text-base md:text-lg leading-[1.6] text-foreground-600">Describe your space in your own words — what matters most to you, and anything we should know. We&apos;ll take it from there.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Button href="#cleary-contact-quote-form">Describe Your Space <i className="ri-arrow-up-line" /></Button>
            <Button href="/services" variant="ghost">Explore Services</Button>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}